import type { DocumentWithTimestamps } from './firebase.ts'
import type { OrgId } from './ids.ts'
import type { Job } from './Job.ts'
import type { JobRequest, UnregisteredUser } from './JobRequest.ts'
import type { MembershipRequest } from './MembershipRequest.ts'
import type { Mentoring } from './Mentoring.ts'
import type { Org } from './Org.ts'
import type { OrgTransactionPaymentResponse } from './OrgTransaction.ts'
import type { ParticipationRequest } from './ParticipationRequest.ts'
import type { Project } from './Project.ts'
import type { Skill } from './Skill.ts'
import type { UserProfile } from './User.ts'

export enum ActivityStatus {
    WAITING = 'waiting',
    CONFIRM = 'confirm',
    ACTIVE = 'active',
    FINISHED = 'finished',
    JOB_DRAFT = 'job_draft'
}

export enum ActivityType {
    JOB_REQUEST = 'job-request',
    PARTICIPATION_REQUEST = 'participation-request',
    MENTORING_REQUEST = 'mentoring-request',
    MEMBERSHIP_REQUEST = 'membership-request',
    TALENTBASE_REQUEST = 'talentbase-request',
    EVENT = 'event',
    KURZ = 'kurz',
    WORKGROUP = 'workgroup',
    STUDY_OPPORTUNITY = 'study-opportunity',
    JOB = 'job',
    JOB_DRAFT = 'job_draft',
    PROJECT = 'project',
    SKILL = 'skill'
}
export type Activity = DocumentWithTimestamps & {
    type: ActivityType
    requestor?: UserProfile | UnregisteredUser | Job | Project | Org
    requested?: UserProfile | Job | Project | Skill
    data:
        | JobRequest
        | ParticipationRequest
        | Mentoring
        | Skill
        | Job
        | Project
        | MembershipRequest
        | OrgTransactionPaymentResponse
    requests?: any
    orgId: OrgId | null
    state?: string // TMP not used,
    status: string
}
